// extracted by mini-css-extract-plugin
export var equalColumn = "_ef-0";